import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import SignalRenewalPeriodFilter from "app/pages/sales-intelligence/modules/signals/components/SignalRenewalPeriodFilter/SignalRenewalPeriodFilter";
import { StyledDropdownLabelGapWrapped } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalsDropdownLabel/styles";
import { StyledInlineFilterWrapper } from "app/pages/sales-intelligence/sub-modules/signals/components/styles";
import type { TechnologySignalFilterViewProps } from "app/pages/sales-intelligence/sub-modules/signals/components/views/TechnologySignalFiltersView/models/TechnologySignalFilterViewProps";

const CompetitorRenewalComingUpView = ({
    children,
    signalAlias,
    selectedValue,
    onValueChange,
}: TechnologySignalFilterViewProps): ReactElement => {
    return (
        <>
            <StyledDropdownLabelGapWrapped data-automation="technology-filter-text">
                {translate("si.signals.management.label.technology.filter-text")}
            </StyledDropdownLabelGapWrapped>
            <StyledInlineFilterWrapper>
                <SignalRenewalPeriodFilter
                    months={selectedValue.periodAmount}
                    signalAlias={signalAlias}
                    onChange={(periodAmount) => onValueChange({ periodAmount })}
                />
            </StyledInlineFilterWrapper>
            <StyledDropdownLabelGapWrapped data-automation="technology-filter-text">
                {translate("si.signals.management.label.technology.filterSecondText")}
            </StyledDropdownLabelGapWrapped>
            <StyledInlineFilterWrapper>{children}</StyledInlineFilterWrapper>
        </>
    );
};

export default CompetitorRenewalComingUpView;
